import React from "react";
import { FiBell, FiX } from "react-icons/fi";

const NotificationPopup = ({ onClose, notifications = [] }) => {
  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "transparent",
          zIndex: 999,
        }}
      />

      {/* Notification Popup */}
      <div
        style={{
          position: "fixed",
          top: "70px",
          right: "20px",
          width: "380px",
          maxHeight: "500px",
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
          zIndex: 1000,
          overflow: "hidden",
          fontFamily: "'Euclid Circular B', sans-serif",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #E8E8E8",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#F8F9FA",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FiBell size={20} color="#464FB1" />
            <span
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#172B4D",
              }}
            >
              Notifications
            </span>
            {notifications.length > 0 && (
              <span
                style={{
                  backgroundColor: "#464FB1",
                  color: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "2px 8px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                {notifications.length}
              </span>
            )}
          </div>
          <FiX size={24} color="#172B4D" style={{ cursor: "pointer" }} onClick={onClose} />
        </div>

        {/* Content */}
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            padding: "16px",
          }}
        >
          {notifications.length === 0 ? (
            // No Notifications
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "#F0F4FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <FiBell size={36} color="#464FB1" />
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#172B4D",
                  marginBottom: "8px",
                }}
              >
                No notifications
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#6B778C",
                  maxWidth: "250px",
                }}
              >
                You're all caught up! We'll notify you when something new arrives.
              </div>
            </div>
          ) : (
            // Notification List
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {notifications.map((notification, index) => (
                <div
                  key={index}
                  style={{
                    padding: "12px",
                    backgroundColor: notification.read ? "#FFFFFF" : "#F0F4FF",
                    borderRadius: "12px",
                    border: "1px solid #E8E8E8",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#F8F9FA";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = notification.read ? "#FFFFFF" : "#F0F4FF";
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#172B4D",
                      marginBottom: "4px",
                    }}
                  >
                    {notification.title}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#6B778C",
                      marginBottom: "8px",
                    }}
                  >
                    {notification.message}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#9AA5B5",
                    }}
                  >
                    {notification.time}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer - only show if there are notifications */}
        {notifications.length > 0 && (
          <div
            style={{
              padding: "12px 20px",
              borderTop: "1px solid #E8E8E8",
              textAlign: "center",
            }}
          >
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#464FB1",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#F0F4FF";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              Mark all as read
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationPopup;
